import React from "react";
import {
  Alert,
  Box,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  TextField,
} from "@mui/material";
import * as Yup from "yup";
import CheckIcon from "@mui/icons-material/Check";
import "./CommunicationDetails.css";
import { Field, Form, Formik } from "formik";
import Colors from "../../../utility/Colors";

const CommunicationDetails = () => {
  const handleSubmitData = async (data) => {
    // Prevent submission if there are file validation errors
    // API call for verify email id
    // dispatch(saveOrUpdateCaseThunk(updateDetailsData));
  };
  return (
    <Box>
      {/* <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
        Mobile Number has been verified successfully
      </Alert> */}
      <Box>
        <Formik
          initialValues={{ emailId: "" }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            handleSubmitData(values);
          }}
        >
          {(props) => (
            <Form>
              <Grid container spacing={1} sx={{ p: 1, display: "flex" }}>
                {[
                  {
                    name: "emailId",
                    label: "emailId",
                    type: "input",
                    required: true,
                  },
                ].map((field) => (
                  <Grid item xs={12} md={12} key={field.name}>
                    <Grid
                      container
                      spacing={2}
                      alignItems="center"
                      justifyContent="space-between"
                      sx={{ p: 1 }}
                    >
                      <Grid item xs={12} md={12}>
                        <Field name={field.name}>
                          {({ field: formikField, meta }) => (
                            <>
                              <InputLabel
                                htmlFor={field.label}
                                sx={{
                                  mb: ".5rem",
                                  fontWeight: "600",
                                  color: "#000",
                                  marginTop: ".75rem",
                                }}
                              >
                                Enter Email Address
                              </InputLabel>
                              <TextField
                                {...formikField}
                                variant="outlined"
                                size="large"
                                fullWidth
                                placeholder="Enter Email Address"
                                required={field?.required}
                                type={
                                  field.type === "checkbox"
                                    ? "checkbox"
                                    : "text"
                                }
                                error={meta.touched && Boolean(meta.error)}
                                helperText={meta.touched && meta.error}
                              />
                            </>
                          )}
                        </Field>
                      </Grid>

                      <Grid item xs={12} sx={{ alignSelf: "flex-end" }}>
                        <Button
                          sx={{
                            background: "rgb(245, 132, 31)",
                            color: "#fff",
                            px: 6,
                            "&:hover": { opacity: 0.9 },
                            alignItems: "bottom",
                          }}
                          type="submit"
                        >
                          Submit
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            </Form>
          )}
        </Formik>
      </Box>
    </Box>
  );
};

export default CommunicationDetails;

const validationSchema = Yup.object({
  emailId: Yup.string().matches(
    /^[^@\s]+@[^@\s]+\.[^@\s]+$/,
    "Enter a valid email address"
  ),
});
